module.exports = __webpack_public_path__ + "img/message.eeb07081.svg";